/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchScansResultsEquipmentModel { 
    id: string;
    name: string;
    nominalHashrate?: number;
    hashrateUnitName?: string | null;
}

